<template>
  <div id="ticketList" v-ripple :class="{selected: showSelected}">
    <template if="ticket">
      <div class="status" :style="{backgroundColor: $store.getters.company.statuses[ticket.status].color}"></div>
      <div class="left">
        <div class="unit">{{ $store.getters.unit(ticket.unit).title ? 'Unit ' + $store.getters.unit(ticket.unit).title : 'Unit Not Populated' }}</div>
        <div class="property">{{ $store.getters.property(ticket.property).name ? $store.getters.property(ticket.property).name : 'Property Not Populated' }}</div>
        <div class="title-value">{{ ticket.title ? ticket.title : 'No Title' }}</div>
      </div>
      <div class="right">
        <div class="date">{{ ticket.created | dateShorthand }}</div>
        <div class="number">#{{ ticket.number }}</div>
      </div>
    </template>
  </div>
</template>

<script>

  import ListItemMixin from '../mixins/listItemMixin.js' 

  export default {
    mixins: [ListItemMixin],
    data () {
      return {

      }
    },
    computed: {
      ticket () {
        return this.$store.getters.ticket(this.item);
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #ticketList {
    
    @include fontPrimary400();

    display: block;
    position: relative;
    width: 100%;
    height: 88px;
    border-bottom: 1px solid $black12;
    background: $white;

    &.selected {
      background: $lightGreen;
    }

    .status {
      position: absolute;
      top: 0;
      left: 0;
      width: 6px;
      bottom: 0;
    }

    .left {
      position: absolute;
      top: 16px;
      left: 22px;
      right: 100px;
      line-height: 20px;

      .unit {
        @include textEllipsis();
        
        font-size: 16px;
      }

      .property {
        @include textEllipsis();
        
        font-size: 14px;
        color: $black54;
      }

      .title-value {
        @include textEllipsis();

        font-size: 12px;
        color: $black54;
        margin: 2px 0 0 0;
      }
    }

    .right {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 95px;
      text-align: right;
      line-height: 16px;
      font-size: 12px;
      color: $black87;
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/TicketList.vue